<template>
  <div v-if="isBrowser">
    <div id="app">
    <v-app>
      <v-toolbar app height="60px" color="rgb(101,169,220)" class="gradient">
      </v-toolbar>
      
      <router-view />

      <v-footer app height="30px"> 
        <v-flex class="footback">Copyright&copy;2019 TWINS CUPID&reg; All Rights Reserved.</v-flex>
      </v-footer>
    </v-app>
    </div>
  </div>
  <div v-else>
    <div id="app">
      <div class="alert">ブラウザーは Chrome もしくは Firefox をお使いください。</div>
      <div class="message">iPad 対応OS：10.X 以上</div>
      <div class="message">iPhone対応OS：10.X以上</div>
      <div class="message">MAC/Windows ブラウザ：GoogleChrome/Firefox</div>
      <div class="message">※InternetExplorer、MicrosoftEdge はサポートご利⽤いただけません。</div>
      <div class="message-l">■動作に関するお問い合わせは<a href="http://abe-j.co.jp/">こちら</a>へお願いします</div>
      <div class='message-ll'><a href='http://twinscupid.jp/index.php'>TWINS CUPID HP</a></div>
    </div>
  </div>
</template>

<script>
import MobileIs from 'ismobilejs';

export default {
  components: {
    },
  data(){
    return{
      isBrowser:false,
    }
  },
  computed:{
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      this.isBrowser = this.browser();
    },
    browser(){
      var Result = false;
      const {detect} = require('detect-browser');
      const browser = detect();
      switch (browser && browser.name) {
        case 'chrome':
        case 'firefox':
          Result = true;
          break;
        default:
          Result = false;
      }

      if(MobileIs.phone){
        Result = true;
      }
      return Result;
    },

  }
}
</script>

<style>

.alert {
  padding: 20px;
  background-color: #f44336; /* Red */
  color: white;
  margin-bottom: 15px;
  text-align:center;
}
.message {
  padding: 5px 100px;
  margin-bottom: 10px;
  text-align: left;
  font-size: 15px;
}        
.message-l {
  padding: 5px 100px;
  margin-bottom: 10px;
  text-align: left;
  font-size: 18px;
}
.message-ll {
    padding: 100px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 25px;
}

.gradient {
  background-image: url("../src/assets/svg/TwinsCupid.svg");
  background-position:center center;
}
.footback{
  text-align:center;
  vertical-align:center;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
